import { HandbookV2 } from 'types'
import { useUpdateHandbook } from '../useUpdateHandbook'
import { FormikHelpers } from 'formik'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { HandbooksStore } from 'stores/HandbooksStore'

export const useHandbookUpdate = (store: HandbooksStore, handbook?: HandbookV2 | null) => {
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const [updateHandbook, isUpdating] = useUpdateHandbook(handbook!, store)

  const onUpdate = async (values: Partial<HandbookV2>, formikHelpers?: FormikHelpers<HandbookV2>) => {
    try {
      const errors = await updateHandbook(values)
      if (!errors) return

      if (formikHelpers) {
        errors.forEach(([attr, err]) => formikHelpers?.setFieldError(attr, err))
      } else {
        showErrorMessageToast('Could not save your changes. Try again later.')
      }
    } catch (err) {
      showErrorMessageToast('Something went wrong, try again')
    }
  }

  return { onUpdate, isUpdating }
}
